/**
 * Opens popup wizard window.
 */
export function popupWizardWindow() {
    // sets defaults (for older browsers)
    let winWidth = 1024;
    let winheight = 768;

    if (screen) {
        winWidth = screen.width;
        winHeight = screen.height;
    }

    let newWizardPopupParam = 'toolbar=no, menubar=no, resizable=no, scrollbars=yes';
    newWizardPopupParam += ', width=' + winWidth;
    newWizardPopupParam += ', height=' + winHeight;
    newWizardPopupParam += ', top=0, left=0';

    newWindow = window.open('about:blank', 'MnumiWizard', newWizardPopupParam);
    newWindow.focus();
}
